<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Places"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider ref="place" rules="" v-slot="{ errors }">
                <v-text-field
                   id="pac-input"
                  :error-messages="errors"
                  v-model="data.place"
                  label="Lugar"
                  prepend-inner-icon="fas fa-file"
                ></v-text-field>
              </ValidationProvider>
                <GoogleMapLoader v-on:select="changeAddress" :show-map="false" style="height: 300px"
                :sendCoordinates="sendCoordinates" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="lat" rules="" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  v-model.number="data.lat"
                  type="Number"
                  label="Latitude"
                  prepend-inner-icon="fas fa-file"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="long" rules="" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  type="Number"
                  v-model.number="data.long"
                  label="Longitude"
                  prepend-inner-icon="fas fa-file"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';
  import GoogleMapLoader from "@/components/maps/GoogleMapLoader";

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm, GoogleMapLoader},
    computed: {
      ...mapState({
        status: state => state.Places.status,
      })
    },
    data() {
      return {
        storeName: 'Places',
        title: "Zonas habilitadas",
        data: {
          place: '',
          lat:'',
          longitude:'',
          location:'',
        }
      }
    },
    methods: {
      sendCoordinates(lat, lng) {
        this.data.lat = lat;
        this.data.long = lng;
      },
      changeAddress(val) {
        this.data.place = val;
      }
    }
  }
</script>
